<template>
  <RxkDialog
    v-model="showInfo"
    width="480"
    title="结束流程"
    :is-loading="loading"
    @sure="handleSure"
    @close="handleClose"
  >
    <div class="tw-p-[16px]">
      <el-form ref="formRef" :rules="rules" :model="formState" label-position="top">
        <el-form-item label="审批结果" prop="result">
          <RxkRadio v-model="formState.result" :list="resultList" />
        </el-form-item>
        <el-form-item label="审批意见" prop="remark">
          <RxkInput v-model="formState.remark" show-word-limit type="textarea" maxlength="1000" />
        </el-form-item>
      </el-form>
    </div>
  </RxkDialog>
</template>
<script lang="ts" setup>
import { ref, computed, reactive, watch, nextTick } from 'vue'
import { RxkDialog } from '@/components/common/RxkDialog'
import { RxkInput, RxkRadio } from '@/components/common'
import { AuthBtn } from '@/components/business/FlowDeal/config'

const props = defineProps({
  modelValue: Boolean,
  info: Object
})
const emit = defineEmits(['update:modelValue', 'submit'])

const showInfo = computed({
  get: () => {
    return props.modelValue
  },
  set: (val: any) => {
    emit('update:modelValue', val)
  }
})

const loading = ref(true)

function handleClose() {
  emit('update:modelValue', false)
}

// form相关
watch(
  () => props.modelValue,
  val => {
    if (val) {
      nextTick(() => {
        if (!formRef.value) return
        formRef.value.resetFields()
      })
    }
  }
)

const formState = reactive({
  result: '',
  remark: ''
})

const formRef = ref()
const rules = computed(() => {
  if (formState.result === 'reject') {
    return {
      result: [{ required: true, message: '请选择退回类型', trigger: 'change' }]
      // remark: [{ required: true, message: '请填写退回原因', trigger: 'change' }]
    }
  }
  return {
    result: [{ required: true, message: '请选择退回类型', trigger: 'change' }]
  }
})

const resultList = [
  { label: '通过', value: AuthBtn.PASS },
  { label: '拒绝', value: AuthBtn.REJECT }
]

async function handleSure(fn: Fn = () => {}) {
  if (!formRef.value) return
  await formRef.value.validate(async (valid: any) => {
    if (valid) {
      emit('submit', {
        action: AuthBtn.CLOSE,
        comment: formState.remark,
        result: formState.result // 通过、拒绝
      })
      handleClose()
      fn()
    } else {
      fn()
    }
  })
}
</script>
